import { ChangeEvent, FC } from 'react';
import { Table, TableContainer, TableHead, TableRow, styled } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

import './table.scss';
import { TableProperties } from './tableProperties';
import { HeaderContent, HeaderTableCell, TableLoader, TableNoData } from './tableHelpers';
import { CustomPagination } from './pagination';
import CustomCheckBox from '../Checkbox';
import { BACKGROUND } from '../../Helpers/colors';

const CustomTableContainer = styled(TableContainer)(() => ({
	overflowY: 'visible',
	overflowX: 'auto',
	border: `1px solid ${BACKGROUND.PRIMARY[100]}`,
}));

const CustomTable: FC<TableProperties> = ({
	headers,
	data,
	TableBody,
	loading,
	hasMobile = true,
	hasPagination = true,
	style,
	type = '',
	checkForLoading = true,
	siblingCount,
}) => {
	const [params, setParams] = useSearchParams();

	const selectAllHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;

		if (checked) {
			params.set('selectAll', 'true');
		} else {
			params.delete('selectAll');
		}
		setParams(params, { replace: true });
	};

	return (
		<CustomTableContainer className={hasMobile ? 'tableContainer' : ''} style={style}>
			<Table>
				<TableHead>
					<TableRow>
						{Boolean(headers) &&
							headers.map((item, index) =>
								item.isSelectAll ? (
									<HeaderTableCell width={40} key={`header-${item.id}-${index}`}>
										<CustomCheckBox
											item={{ id: 'all', checked: Boolean(params.get('selectAll')) }}
											onChange={selectAllHandler}
											style={{ marginRight: 0 }}
										/>
									</HeaderTableCell>
								) : (
									<HeaderContent item={item} key={`header-${item.id}-${index}`} />
								),
							)}
					</TableRow>
				</TableHead>
				{loading && <TableLoader spanScope={headers.length} type={type} />}
				{(checkForLoading ? !loading : true) && data.query && data.query.length && <TableBody data={data.query} />}
				{!loading && !data.query?.length && <TableNoData spanScope={headers.length} />}
			</Table>
			{hasPagination && <CustomPagination data={data} type={type} siblingCount={siblingCount} />}
		</CustomTableContainer>
	);
};

export default CustomTable;
